<template>
  <div class="invoicing-view">
    <grid-details-component
      v-if="customer && invoiceCustomer"
      :display_spec="invoiceCustomerSpecs"
      :item="invoiceCustomer"
      :item_keys="companyInvoicingKeys">
    </grid-details-component>
    <message-component v-if="companyInvoicing" :level="'info'">
      <translate>Invoices will be sent to the customer personally.</translate>
    </message-component>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent.vue'
  import { invoiceCustomerSpecs } from '@/display_context/display_context'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'invoicing-view',
    components: {
      GridDetailsComponent,
      MessageComponent
    },
    data () {
      return {
        invoiceCustomerSpecs: invoiceCustomerSpecs,
        customer_invoicing_keys: ['reference', 'distribution'],
        customer_company_invoicing_keys: ['reference', 'distribution', 'companyName', 'postalCode', 'postalAddress', 'postalCity', 'email', 'marking', 'phone', 'gln', 'vatNumber']
      }
    },
    computed: {
      ...mapState({
        customer: state => state.profileModule.customerProfile
      }),
      invoiceCustomer () {
        return this.customer && this.customer.invoicing
      },
      companyInvoicing () {
        return this.customer && this.customer.invoicing && !this.customer.invoicing.useCompanyAddress
      },
      companyInvoicingKeys () {
        return this.customer.invoicing.useCompanyAddress ? this.customer_company_invoicing_keys : this.customer_invoicing_keys
      }
    }
  }
</script>
